import classNames from "classnames";
import React, { FC, memo } from "react";

import { IImgProps, Img } from "@/eworkitComponents/components/Img";
import { TStyleSize } from "@/eworkitComponents/components/Style";

import "./_logo.scss";

export interface ILogoProps extends IImgProps {
  size?: TStyleSize | "auto";
  orientation?: "landscape" | "portrait";
  position?: "top" | "left" | "bottom" | "right" | "center";
}

export const Logo: FC<ILogoProps> = memo(({ className, size = "md", position = "center", orientation, ...props }) => {
  const classes = classNames(
    "logo",
    `logo--size-${size}`,
    `logo--position-${position}`,
    { [`logo--orientation-${orientation}`]: !!orientation },
    className,
  );

  return <Img className={classes} {...props} />;
});
